import React from 'react';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCalendar } from '../../contexts/CalendarContext';
import CalendarView from '../../components/Calendar/CalendarView';

const CalendarPage = () => {
  const { t } = useTranslation('calendar');
  const { selectedCalendar, calendars } = useCalendar();

  return (
    <div className="h-full flex flex-col bg-white dark:bg-[var(--color-bg-base)]">
      {selectedCalendar ? (
        <div className="flex-1 overflow-hidden">
          <CalendarView calendar={selectedCalendar} />
        </div>
      ) : calendars.length > 0 ? (
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center text-slate-500 dark:text-slate-400">
            <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-[var(--color-bg-elevated)] flex items-center justify-center mb-6 mx-auto border border-slate-200 dark:border-white/10">
              <Calendar className="w-10 h-10 text-slate-400 dark:text-[var(--color-text-secondary)]" strokeWidth={1.5} />
            </div>
            <h2 className="text-xl font-bold mb-2 text-slate-900 dark:text-white">{t('page.selectCalendarTitle')}</h2>
            <p className="text-sm text-slate-500 dark:text-[var(--color-text-secondary)]">{t('page.selectCalendarHint')}</p>
          </div>
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center p-6">
          <div className="text-center text-slate-500 dark:text-slate-400">
            <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-[var(--color-bg-elevated)] flex items-center justify-center mb-6 mx-auto border border-slate-200 dark:border-white/10">
              <Calendar className="w-10 h-10 text-slate-400 dark:text-[var(--color-text-secondary)]" strokeWidth={1.5} />
            </div>
            <h2 className="text-xl font-bold mb-2 text-slate-900 dark:text-white">{t('page.emptyTitle')}</h2>
            <p className="text-sm text-slate-500 dark:text-[var(--color-text-secondary)]">{t('page.emptyHint')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarPage;
